module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_7005.f21096a6.png";